import {
  createDefaultVendorOrderInformationData,
  IVendorOrderInformationData,
  IVendorOrderInformationRequest,
} from './IVendorOrderInformation';

export interface IVendorPayoffInformationRequest extends Omit<IVendorOrderInformationRequest, 'titleSearchId'> {
  payoffRequestId: string;
  eta?: string;
}

export interface IVendorPayoffInformationData extends Omit<IVendorOrderInformationData, 'titleSearchId'> {
  payoffRequestId: string;
  eta?: string;
}

export const createDefaultVendorPayoffInformationData = (): IVendorPayoffInformationData => {
  const { titleSearchId, ...rest } = createDefaultVendorOrderInformationData();
  return {
    ...rest,
    payoffRequestId: '',
  };
};

export const convertFromVendorPayoffInformationRequestToVendorPayoffInformationData = (
  data: IVendorPayoffInformationRequest
): IVendorPayoffInformationData => data;
export const convertFromVendorPayoffInformationDataToVendorPayoffInformationRequest = (
  data: IVendorPayoffInformationData
): IVendorPayoffInformationRequest => data;
